<template>
  <div class="w-full max-w-2xl" :dir="isRtl === true ? 'rtl' : 'ltr'">
    <div class="form-control w-full mb-4">
      <label class="label" :style="isRtl === true ? { textAlign: 'right' } : { textAlign: 'left' }">
        <span class="label-text font-medium">{{ t('agentCreate.personality.nameLabel', 'Agent name') }}</span>
      </label>
      <input v-model="agentName" type="text" class="input input-bordered w-full" :placeholder="t('agentCreate.personality.namePlaceholder', 'e.g. Maya')" />
    </div>
    <div class="form-control w-full mb-4">
      <label class="label" :style="isRtl === true ? { textAlign: 'right' } : { textAlign: 'left' }">
        <span class="label-text font-medium">{{ t('agentCreate.personality.genderLabel', 'Gender / voice style') }}</span>
      </label>
      <div class="flex flex-wrap -m-1">
        <button
          v-for="option in genderOptions"
          :key="option.id"
          type="button"
          class="btn btn-sm m-1"
          :class="selectedGender === option.id ? 'border-stone-400 bg-stone-100 dark:bg-stone-800' : ''"
          @click="selectedGender = option.id"
        >
          {{ option.label }}
        </button>
      </div>
    </div>
    <div class="form-control w-full mb-2">
      <label class="label" :style="isRtl === true ? { textAlign: 'right' } : { textAlign: 'left' }">
        <span class="label-text font-medium">{{ t('agentCreate.personality.personalityLabel', 'Personality & tone') }}</span>
      </label>
      <textarea
        v-model="personality"
        rows="4"
        class="textarea textarea-bordered w-full text-base"
        :placeholder="t('agentCreate.personality.personalityPlaceholder', 'e.g. Warm, concise, professional — uses simple language and stays patient.')"
      ></textarea>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from '@/i18n';

const { t, currentLanguage, availableLanguages } = useI18n();

const isRtl = computed(() => {
  const language = availableLanguages.value.find((item) => item.code === currentLanguage.value);
  if (language === undefined || language === null) {
    return false;
  }
  return language.dir === 'rtl';
});

const agentName = ref('');
const personality = ref('');
const selectedGender = ref('neutral');

const genderOptions = computed(() => [
  { id: 'female', label: t('agentCreate.personality.gender.female', 'Female') },
  { id: 'male', label: t('agentCreate.personality.gender.male', 'Male') },
  { id: 'neutral', label: t('agentCreate.personality.gender.neutral', 'Neutral') }
]);

function buildPayload() {
  return {
    agentName: agentName.value.trim(),
    personality: personality.value.trim(),
    gender: selectedGender.value
  };
}

function canSubmit() {
  const payload = buildPayload();
  if (payload.agentName.length === 0) {
    return false;
  }
  if (payload.personality.length === 0) {
    return false;
  }
  if (payload.gender === '') {
    return false;
  }
  return true;
}

defineExpose({
  buildPayload,
  canSubmit
});
</script>
